import Hooks from './assets/js/classes/core/Hooks';

const hooks = Hooks();

export const onValidationApply = hooks.add('validation-apply');

export const onValidationClear = hooks.add('validation-clear');

export const onWrapperHeightChange = hooks.add('wrapper-height-change');

export default hooks;
